import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core';

import { UiSelectAtomComponent, UiSelectOption } from 'src/app/shared/ui/atoms/ui-select/ui-select.component';

// Categoría/subcategoría del dominio de ofertas (OfferService): solo se leen 'id'/'name'.
interface SelectableCategory {
  id: string | number;
  name: string;
}

@Component({
  selector: 'app-category-select',
  imports: [UiSelectAtomComponent],

  template: `
    <p>{{ label() }}</p>
    <app-ui-select
      [selectId]="selectId()"
      [name]="name()"
      [options]="options()"
      [selectedValue]="selectedValue()"
      [placeholder]="placeholder()"
      [showPlaceholder]="showPlaceholder()"
      [placeholderDisabled]="placeholderDisabled()"
      (selectionChange)="selectionChange.emit($event)" />
  `,

  styleUrl: './category-select.component.scss',

  changeDetection:
    ChangeDetectionStrategy.OnPush
})
export class CategorySelectMoleculeComponent {
  readonly label =
    input('¿Qué estás buscando?');

  readonly selectId =
    input.required<string>();

  readonly name =
    input('category');

  readonly categories =
    input<SelectableCategory[]>([]);

  readonly selectedValue =
    input<string | number | null>(null);

  readonly placeholder =
    input(' Elige lo que necesites ');

  readonly showPlaceholder =
    input(true);

  readonly placeholderDisabled =
    input(false);

  readonly selectionChange =
    output<Event>();

  readonly options = computed<UiSelectOption[]>(() =>
    this.categories().map(cat => ({ value: cat.id, label: cat.name }))
  );
}
